import classnames from 'classnames';
import type {
  ButtonHTMLAttributes,
  MouseEvent,
  ReactElement,
  ReactNode
} from 'react';
import styles from './Button.module.scss';

export type Props = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'type' | 'onClick'
> & {
  children: ReactNode;
  className?: string;
  type?: 'default' | 'success' | 'primary' | 'danger' | 'link' | 'text';
  disabled?: boolean;
  submit?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

export function Button(props: Props): ReactElement {
  const {
    children,
    onClick,
    className,
    type = 'default',
    disabled = false,
    submit,
    ...otherProps
  } = props;
  const buttonClassName = classnames(className, styles[type]);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <button
      {...otherProps}
      type={submit ? 'submit' : 'button'}
      onClick={handleClick}
      className={buttonClassName}
      tabIndex={props.disabled ? -1 : 0}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
